import { useHistory } from "react-router-dom";

// Components
import Block from "../../components/Block/BlockContainer";
import { ConferencesPrevious } from "../../components/ConferencesPrevious/ConferencesPrevious";
import ConferencesVideos from "./ConferencesVideos/ConferencesVideos";
import { LoadingPageContainer as LoadingPage } from "../../components/LoadingPage/LoadingPageContainer";


// CSS
import styles from "./conferences.module.scss";

export const Conferences = (props) => {
    const { blocks, loading, } = props;

    /**
     * Router Hooks
     */

    const history = useHistory();

    /**
     * Constants
     */

    const isLoading = loading.blocks || loading.conferences;

    /**
     * End Hooks
     */

    function renderBlocks() {
        return (
            blocks &&
            blocks.map((block, i) => {
                return <Block {...block} key={i} />;
            })
        );
    }

    return (
        <div className={styles.conferences}>
            {isLoading && <LoadingPage />}
            {renderBlocks()}
            <ConferencesPrevious {...props} history={history} />
            <ConferencesVideos {...props} history={history} />
        </div>
    );
};
